import { Observable } from 'rxjs';
import Dummy from '../../utils/dummy';
import lastShowsChannel from './request';
const WAITING_TIME = 100;

function lastShowsChannelObservable(channelCode: string, channelId: string) {
  return new Observable((subscriber) => {
    subscriber.next(Dummy.getPhoto());
    lastShowsChannel(channelCode, channelId).then((data) => {
      setTimeout(() => {
        subscriber.next({ data });
        subscriber.complete();
      }, WAITING_TIME);
    });
  });
}
export default lastShowsChannelObservable;
